<template>
    <div class="pt-2">
        <b-row>
            <b-col cols="12">
                <div class="card-title">
                    Actions
                    <span style="float: right;">
                        <b-button variant="primary">Add Log Entry</b-button>
                    </span>
                </div>
            </b-col>
            <b-col cols="12">
                TABLE GOES HERE
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col> <!--  :admin="true" :viewFile="clientMediaFile(view.spreadify_uid)" :step="view.render_order" @downloadFile=processFileDownload @uploaderData="processUpload" @formDataUpdated="updateFormData" -->
                <form-plugin uid="6231a90e26aa1"></form-plugin>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data:() => ({}),
    computed:{},
    methods:{},
    mounted(){},
}
</script>

<style>

</style>